export default __webpack_public_path__ + "images/assets/ed2abe8cccb232994e409a77c281a9b5.svg";